import {
  DigitalProduct,
  PrintProduct,
  Product,
} from "../../../../../common/api/decimal/methods/product.ts";
import {
  isDigitalProduct,
  isOutOfStock,
  isPrintProduct,
} from "../../../product/common/productUtils.ts";
import { CourseMaterial } from "../coursesLoader.ts";
import { CartItem } from "../../../../../common/api/decimal/methods/cart.ts";

export function getStoreProducts(product?: Product[]) {
  const digitalProduct = product?.find((p) => isDigitalProduct(p)) as
    | DigitalProduct
    | undefined;
  const printProduct = product?.find((p) => isPrintProduct(p)) as
    | PrintProduct
    | undefined;
  const isPrintOutOfStock = printProduct?.variants?.every((variant) =>
    isOutOfStock(variant)
  );

  return {
    digitalProduct,
    printProduct,
    defaultVariant: (digitalProduct ?? printProduct)?.variants?.[0],
    isPrintOutOfStock,
    isOutOfStock: !!(!digitalProduct && isPrintOutOfStock),
  };
}

export function findMaterialInCart(
  material: CourseMaterial,
  lineItems: CartItem[] = []
) {
  const { digitalProduct, printProduct } = getStoreProducts(material.product);
  const productIsbns = [material.vbid];
  if (digitalProduct?.canonicalIsbn) {
    productIsbns.push(digitalProduct?.canonicalIsbn);
  }
  if (printProduct?.canonicalIsbn) {
    productIsbns.push(printProduct?.canonicalIsbn);
  }
  return lineItems.find((item) => productIsbns.includes(item.canonicalIsbn));
}

export function isMaterialInStoreCart(
  material: CourseMaterial,
  lineItems: CartItem[] = []
) {
  return findMaterialInCart(material, lineItems) !== undefined;
}

export function isMaterialOutOfStock(material: CourseMaterial) {
  const { isOutOfStock } = getStoreProducts(material.product);
  return isOutOfStock;
}
